$ = jQuery;


$(document).ready(function () {

    $(".rwd_header .menuOpen").click(function () {
        $('.rwd_header #rwd-menu').toggleClass("opened");
    });

    $(".rwd_header #rwd-menu .site-nav--has-dropdown .subItems").click( function () {
        $(this).parent().next().slideToggle(300);
        $(this).toggleClass("active");
    });

    /*Home Top Slider*/
    var homeTopSwiper = new Swiper('.vb_home-slider', {
        loop: true,
        speed: 1500,
        effect: 'fade',
        autoHeight: true,
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 4000,
            disableOnInteraction: false
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
    });

    /*Home Featured Products SLider*/
    var hfpSwiper = new Swiper('.vb_homeFP .fp-slider', {
        loop: true,
        spaceBetween: 20,
        slidesPerView: 4,
        speed: 2500,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        breakpoints: {
            480: {
                slidesPerView: 1
            },
            640: {
                slidesPerView: 2
            },
            768: {
                slidesPerView: 3
            }
        }
    });

    /*Home Testimonials Slider*/
    var testiSwiper = new Swiper('.vb_homeTestimonials .testi-slider', {
        loop: true,
        spaceBetween: 20,
        slidesPerView: 2,
        speed: 2500,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        breakpoints: {
            768: {
                slidesPerView: 1
            },
        }
    });

    (function ($) {
        $('.tab ul.tabs').addClass('active').find('> li:eq(0)').addClass('current');

        $('.tab ul.tabs li').click(function (g) {
            var tab = $(this).closest('.tab'),
                index = $(this).closest('li').index();

            tab.find('ul.tabs > li').removeClass('current');
            $(this).closest('li').addClass('current');

            tab.find('.tab_content').find('div.tabs_item').not('div.tabs_item:eq(' + index + ')').slideUp();
            tab.find('.tab_content').find('div.tabs_item:eq(' + index + ')').slideDown();

            g.preventDefault();
        });
    })(jQuery);

    document.querySelector('.menuOpen').addEventListener('click', function () {
        document.querySelector('.menuOpen').classList.toggle('open');
    });

    var countDownDate = new Date($('#healthEducation').data('time')).getTime();

    setInterval(function () {

        // Get todays date and time
        var now = new Date().getTime();

        // Find the distance between now an the count down date
        var distance = countDownDate - now;

        // Time calculations for days, hours, minutes and seconds
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // Output the result in an element with id="healthEducation"
        document.getElementById("healthEducation").innerHTML = "<div class='box'><div><span class='number'>" + days + " </span><span>days</span></div><div><span class='number'> " + hours + "</span><span>hours </span></div><div><span class='number'>"
            + minutes + "</span><span>minutes </span></div><div><span class='number'>" + seconds + "</span><span>seconds </span></div></div>";

        // If the count down is over, write some text
        if (distance < 0) {
            clearInterval(x);
            document.getElementById("healthEducation").innerHTML = "EXPIRED";
        }
    }, 1000);

});

// Set the date we're counting down to

// Update the count down every 1 second
